import { handleize } from '../../../../js/helpers/handleize';
import { getLazyLinkToImage } from '../../../../js/helpers/getLazyLinkToImage';
import { isCustomProduct, state } from '../../store/state';
import { frameColorsForRender } from './frameColorsForRender';
import triggers from '../../store/triggers';
const vNode = window.vNode;
const toColorVNode = (layout, color) => {
    const imgName = isCustomProduct
        ? `${handleize(layout)
            .replace(/vertical-|horizontal-|panoramic-/g, '')}-${handleize(color)}-frame.png`
        : `${handleize(layout)}-${handleize(color)}-frame.png`;
    const imgSrc = `https://cdn.shopify.com/s/files/1/1568/8443/files/${imgName}`;
    const lazyImgSrc = getLazyLinkToImage(imgSrc);
    return vNode.create('div', {
        class: 'FrameColor-ow regular-product-FrameColor-ow has-preview--ow'
    }, [
        vNode.create('input', {
            type: 'radio',
            class: 'prd-options',
            id: `FrameColor-${handleize(color)}`,
            name: 'properties[Frame Color]',
            value: color,
            checked: color === state.frameColor,
            data: {
                avalue: color,
                optionName: 'Frame Color'
            },
            events: {
                click: () => {
                    state.frameColor = color;
                    triggers.emitEvent('state:frameColor', [color]);
                }
            }
        }),
        vNode.create('label', {
            class: 'FrameColor-labels regular-product-FrameColor-labels has-preview--labels d:flex fd:column',
            for: `FrameColor-${handleize(color)}`,
            data: {
                avalue: color,
                optionName: 'Frame Color',
                gaEvent: `["Product", "click", "Frame Color : ${color}"]`
            }
        }, [
            vNode.create('img', {
                class: 'FrameColor-image has-preview--image w:100 skeleton',
                src: imgSrc,
                srcset: `
                ${lazyImgSrc.replace('{width}', '70')} 1x,
                ${lazyImgSrc.replace('{width}', '140')} 2x,
                ${lazyImgSrc.replace('{width}', '210')} 3x,
              `,
                height: 70,
                width: 70,
                loading: 'lazy',
                alt: `${handleize(color)} frame`
            }),
            vNode.create('span', { class: 'text:uppercase text:center' }, [color])
        ])
    ]);
};
export const frameColorsVNode = (layout) => {
    return vNode.create('div', {
        class: 'selector-wrapper selector-wrapper--frame-color js product-form__item'
    }, [
        vNode.create('label', {
            class: 'label-option'
        }, [
            vNode.create('span', {
                class: 'label-option-text'
            }, ['CHOOSE FRAME COLOR'])
        ]),
        ...frameColorsForRender[layout].map(({ name }) => toColorVNode(layout, name)),
        ...(state.frameColor !== 'Black'
            ? [
                vNode.create('p', { class: 'product-option-description' }, ['The selected frame color is not represented in the preview'])
            ]
            : [])
    ]);
};
